export const ASSETS = {
  // Church V logo (green/blue) — the actual Nueva Vida Internacional logo
  churchLogo:
    "https://customer-assets.emergentagent.com/job_fe-y-radio/artifacts/85oo94ee_edeewsrwrewrewrew.jpeg",
  // Radio program logo (Impacto de Dios al Pueblo - teal disc)
  radioLogo:
    "https://customer-assets.emergentagent.com/job_fe-y-radio/artifacts/gf6wkgly_erfef.png",
  // Scranton For Christ cityscape background
  scrantonBg:
    "https://customer-assets.emergentagent.com/job_fe-y-radio/artifacts/k3105nu2_FGHHF.png",
  // Caminata flyer 1 (English-leaning, with sponsors)
  flyerA:
    "https://customer-assets.emergentagent.com/job_fe-y-radio/artifacts/3t68ox5f_WhatsApp%20Image%202026-06-10%20at%2012.12.23%20AM.jpeg",
  // Caminata flyer 2 (Spanish-leaning, with church logos)
  flyerB:
    "https://customer-assets.emergentagent.com/job_fe-y-radio/artifacts/7pg79283_WhatsApp%20Image%202026-06-13%20at%2010.52.32%20AM.jpeg",
};

export const RECURRING_SERVICES = [
  {
    id: "rec-dom",
    title: "Culto Dominical",
    weekday: 0,
    weekdayLabel: "Domingo",
    timeLabel: "10:00 AM – 1:00 PM",
    startHour: 10,
    endHour: 13,
    location: "120 S Main Ave, Scranton, PA",
    description:
      "Servicio principal con alabanza, predicación y ministración del Espíritu Santo.",
    accent: "primary",
  },
  {
    id: "rec-mie",
    title: "Estudio Bíblico",
    weekday: 3,
    weekdayLabel: "Miércoles",
    timeLabel: "7:00 PM – 9:00 PM",
    startHour: 19,
    endHour: 21,
    location: "120 S Main Ave, Scranton, PA",
    description:
      "Profundizamos en la Palabra de Dios y crecemos como discípulos.",
    accent: "secondary",
  },
  {
    id: "rec-vie",
    title: "Culto de Viernes",
    weekday: 5,
    weekdayLabel: "Viernes",
    timeLabel: "7:00 PM – 9:00 PM",
    startHour: 19,
    endHour: 21,
    location: "120 S Main Ave, Scranton, PA",
    description: "Servicio de avivamiento y libertad en el Espíritu.",
    accent: "secondary",
  },
];

export function nextOccurrence(weekday, fromDate = new Date()) {
  const d = new Date(fromDate);
  const diff = (weekday - d.getDay() + 7) % 7 || 7;
  d.setDate(d.getDate() + diff);
  return d;
}
